import { IntegrationsAPI } from "api/application/Integrations";

export const fetchIntegrations = async (props) => {
  const { access, actualProject, limitsIntegrations } = props.data;

  try {
    const obj = new IntegrationsAPI(actualProject.id, access, props);
    const res = await obj.get_integrations();
    const integrations = [];

    res.forEach((integration) => {
      const alreadyExists = integrations.find(
        (int) => int.channel === integration.channel
      );

      if (
        [
          "zendesk_full",
          "zendesk_chat",
          "centridesk",
          "sunco",
          "gpt-3",
        ].includes(integration.channel) &&
        !alreadyExists
      ) {
        if (limitsIntegrations?.[integration.channel]?.multiple) {
          const multiple = res.filter((i) => i.channel === integration.channel);
          integration.multiple = multiple.map((m) => ({
            id: m.id,
            name: m.name ?? m.channel,
            use_custom_fields: m.info?.use_custom_fields,
          }));
        }

        integrations.push(integration);
      }
    });

    return integrations;
  } catch (err) {
    console.error(err);
    return [];
  }
};

